import { IncidentNotificationType, IncidentReviewingNotificationPayload } from "@/types/incident.types";
import { hasStringProperty, isRecord } from "@/utils/type-guards";

import type { NotificationAdapter } from "./base/notification-adapter.interface";

const isIncidentReviewingNotificationPayload = (
    payload: Record<string, unknown>
): payload is IncidentReviewingNotificationPayload =>
    payload.type === IncidentNotificationType.REVIEWING &&
    hasStringProperty(payload, "incidentId") &&
    hasStringProperty(payload, "title") &&
    hasStringProperty(payload, "body");

export const createIncidentNotificationAdapter = ({
    handleIncidentReviewingNotification,
}: {
    handleIncidentReviewingNotification: (notification: IncidentReviewingNotificationPayload) => void;
}): NotificationAdapter<IncidentReviewingNotificationPayload> => {
    return {
        canHandle: (payload: unknown): payload is IncidentReviewingNotificationPayload => {
            if (!isRecord(payload) || typeof payload.type !== "string") {
                return false;
            }
            return isIncidentReviewingNotificationPayload(payload);
        },
        process: (payload: unknown) => {
            if (!isRecord(payload) || !isIncidentReviewingNotificationPayload(payload)) {
                return;
            }
            handleIncidentReviewingNotification(payload);
        },
    };
};
